module.exports = __webpack_public_path__ + "img/powered_by.28ce7c04.svg";